import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isEmail } from '../utils/utils'

class AuthLogin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      showPassword: false
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.togglePassword = this.togglePassword.bind(this)
  }

  onSubmit (e) {
    e.preventDefault()
    const credentials = {
      email: this.state.email,
      password: this.state.password,
      domain: this.state.domain
    }
    this.props.signin(credentials)
  }

  togglePassword (e) {
    e.preventDefault()
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  render () {
    const { isProcessing, isError, errorMessage, className } = this.props
    const classNamehasError = isError ? 'has-error' : ''
    return (
      <div className={className}>
        <h1 className='main-panel__heading'>
          Login no Companhia.Edu
          <small className='main-panel__subheading'>Entre com as suas credenciais abaixo</small>
        </h1>
        { isError ? <div className='has-error'>{errorMessage}</div> : null }
        <form onSubmit={this.onSubmit} name='form'>
          <div className={`input__group ${classNamehasError}`}>
            <label>Login</label>
            <input
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
              type='email'
              className='form-control'
              placeholder='Login'
              required=''
            />
          </div>
          <div className={`input__group ${classNamehasError}`}>
            <label>Senha</label>
            <input
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              type={this.state.showPassword ? 'text' : 'password'}
              placeholder='Senha de acesso'
              required=''
            />
            <div onClick={this.togglePassword} className='input__group--addon'>
              <span className={`fa fa-fw ${this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
            </div>
            <div className='has-text-right'>
              <Link to='forget-password'>Esqueceu a senha?</Link>
            </div>
          </div>
          <div className='has-text-centered'>
            <button className='button is-primary' type='submit' disabled={!isEmail(this.state.email) || !this.state.password || isProcessing}>
              { isProcessing ? 'Carregando...' : 'Login' }
            </button>
          </div>
        </form>
      </div>
    )
  }
}

AuthLogin.propTypes = {
  isProcessing: PropTypes.bool,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  signin: PropTypes.func,
  className: PropTypes.string
}

export default AuthLogin



// WEBPACK FOOTER //
// ./src/components/AuthLogin.js